import AddUsersGroupModal from './AddUsersGroupModal';

export default AddUsersGroupModal;
